import React from 'react';
import { Formik, Form, Field, ErrorMessage, FieldArray } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { getUserRole } from "../utils/index";
import apiUrl from "../apiUrlConstant";
import axios from "axios";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class TaskAdd extends React.Component {

    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            users: [],
            role: getUserRole(),
            initialValues: {

            }
        };
    }
    componentDidMount() {
        if (this.state.role === 'admin') {
            var self = this;
            axios({
                method: "get",
                url: apiUrl.apiUrl.url + '/user/get-members',
            }).then(function (response) {
                self.setState({
                    users: response.data.data
                });
            });
        }
    }

    closeModal =() => {
        this.props.closeModal();
    }

    render() {
        return (
            <div>
                {/* <h3>Add Task</h3>
                <p>{this.props.leadId}</p> */}
                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        if (!this.validator.allValid()) {
                            this.validator.getErrorMessages();
                            this.validator.showMessages();
                            //this.forceUpdate();
                            return false;
                        }

                        values.lead_id = this.props.leadId;

                        var self = this;
                        axios({
                            method: "post",
                            url: apiUrl.apiUrl.url + "/leads/create-task",
                            data: values,
                        }).then(function (response) {
                            if (response.data.status == 'success') {
                                setTimeout(() => {
                                    self.props.closeModal(); // Close modal after form submission
                                }, 1000);
                            } else {
                                actions.setSubmitting(false);
                                actions.setErrors(response.data);
                            }
                        });
                    }
                    }
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <>
                            <div className="unitFormContainerNew">
                                <Form 
                                autoComplete="off"
                                onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                                    <div className="newGridSectionParent">
                                        <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">

                                            {this.state.role === 'admin' && (
                                                <div className="newGridSectionInner">
                                                    <label>Assign To</label>
                                                    <div className="position-relative">
                                                        <Field as="select" name="user_id" onChange={handleChange}>
                                                            <option value="">Select Member</option>
                                                            {this.state.users.map(user => (
                                                                <option key={user.id} value={user.id}>{user.name}</option>
                                                            ))}
                                                        </Field>
                                                        {this.validator.message("User", values.user_id, "required", { className: "text-danger" })}
                                                    </div>
                                                </div>
                                            )}

                                            <div className="newGridSectionInner">
                                                <label>Task <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Field type="text" name="task" onChange={handleChange} />
                                                    {this.validator.message("Task", values.task, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Description</label>
                                                <div className="position-relative">
                                                    <Field as="textarea" name="description" onChange={handleChange} />
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Due Date <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Field type="date" name="duedate" onChange={handleChange} />
                                                    {this.validator.message("Due Date", values.duedate, "required", { className: "text-danger" })}
                                                </div>
                                            </div>

                                            <div className="newGridSectionInner">
                                                <label>Reminder Date and Time</label>
                                                <div className="position-relative">
                                                    <Field type="datetime-local" name="datetime" onChange={handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                            <button type="button" className='cancel_button' onClick={this.closeModal}>
                                                Cancel
                                            </button>
                                            <button type="submit" className='add_button' disabled={isSubmitting}>
                                                {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            </div>

                        </>
                    )}

                </Formik>
            </div>
        );
    }
};

export default TaskAdd;